/** API route map: URLS.Controller.ClientPayrollConfiguration */
export const ClientPayrollConfiguration = {
      Name: 'ClientPayrollConfiguration/',
      UpdateClientPayrollProcessingOption: 'update-client-payroll-processing-option',
      GetAll: 'getall',
};
